<style lang="scss" scoped>
.button-block {
  .el-button.is-plain {
    --el-button-hover-text-color: var(--el-color-primary);
    --el-button-hover-bg-color: #ffffff;
    --el-button-bg-color: #ffffff;
    --el-button-border-color: var(--el-color-primary);
  }
}
</style>

<template>
  <div class="fixed left-0 top-0 z-10 h-64px min-w-1200px w-full flex items-center justify-between px-60px" :style="{ backgroundColor: navColor }">
    <div class="h-full flex items-center">
      <div class="mr-100px h-28px w-146px bg-[url(@/assets/image/logo-top.png)] bg-cover bg-no-repeat"></div>
      <div class="h-full flex items-center">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="mr-40px h-full cursor-pointer text-16px text-[#333333] leading-64px"
          :class="{
            'text-#002FBE font-semibold border-b-2px border-b-solid border-b-[#002FBE]': currentNavPath === item.path,
          }"
          @click="toPage(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div v-if="!userStore.isLogined" class="button-block">
      <el-button type="primary" size="large" @click="onLogin">登录</el-button>
      <el-button type="primary" size="large" plain @click="onRegister"> 注册 </el-button>
    </div>
    <div v-if="userStore.isLogined" class="flex cursor-pointer items-center">
      <el-dropdown placement="bottom">
        <p class="mr-3 max-w-200px truncate text-14px">{{ userTitle }}</p>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="onLink('/user-center/account-info')">账户中心</el-dropdown-item>
            <el-dropdown-item v-if="userStore.joinState === 2" @click="onLink('/user-center/promotion-record')">推广管理</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <icon class="cursor-pointer text-#002FBE" type="yiyuan-tuichu" size="24" @click="onLogout"></icon>
    </div>
  </div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/index'
import { useEvent } from '@/event/index'
import { LOGOUT } from '@/event/modules/site'

const event = useEvent()
const userStore = useUserStore()

const router = useRouter()
const route = useRoute()

const accountInfo = computed(() => userStore.accountInfo)

// const userInfo = computed(() => userStore.userInfo)
// const maskMobile = computed(() => {
//   return userInfo.value.mobile.replace(/(\d{3})\d+(\d{4})/, '$1****$2')
// })

// /**
//  * 姓名打码处理
//  * @param name 需要处理的姓名
//  * @returns 处理后的姓名
//  */
// const maskName = (name) => {
//   if (!name || typeof name !== 'string') return ''

//   const len = name.length

//   if (len === 1) {
//     return '*'
//   } else if (len === 2) {
//     return name[0] + '*'
//   } else if (len >= 3) {
//     return name[0] + '*'.repeat(len - 2) + name[len - 1]
//   }

//   return name
// }

const userTitle = computed(() => {
  let title = accountInfo.value?.masterMobile
  // 入驻成功
  if (userStore.joinState === 2) {
    title = accountInfo.value?.corpName
    // // 企业-展示完整名称
    // if (userInfo.value.companyType === 1) {
    //   title = userInfo.value.corpName
    // } else {
    //   title = maskName(userInfo.value.userName)
    // }
  }
  return title
})

const navList = [
  {
    name: '首页',
    path: '/',
  },
  {
    name: '供应链票据',
    path: import.meta.env.VUE_APP_YLT_URL, // '/letter-sheet',
    isOuterLink: true,
  },
  {
    name: '运营推广',
    path: '/operation',
  },
  {
    name: '合作案例',
    path: '/cooperation',
  },
  {
    name: '关于我们',
    path: '/about',
  },
  {
    name: '城市合伙人',
    path: '/city-partner',
  },
]
const currentNavPath = computed(() => route.path)
const navColor = ref('transparent')

const toPage = (item) => {
  // 外链跳转
  if (item.isOuterLink) {
    return window.open(item.path, '_blank')
  }
  router.push(item.path)
  // currentNavPath.value = item.path
}

watch(
  () => route.path,
  (newPath) => {
    // currentNavPath.value = newPath
    if (['/login', '/register', '/reset-password'].includes(newPath)) {
      navColor.value = 'rgba(255, 255, 255, .6)'
    }
  },
  { immediate: true },
)

const handleScroll = () => {
  const threshold = 68
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  navColor.value = scrollTop > threshold ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, .6)'
}

const onLogin = () => {
  let query = {}
  if (!['/login', '/register', '/'].includes(route.path)) {
    query.fromPath = route.path
  }
  router.push({ path: '/login', query })
}
const onRegister = () => {
  let query = {}
  if (!['/login', '/register', '/'].includes(route.path)) {
    query.fromPath = route.path
  }
  router.push({ path: '/register', query })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
const onLink = (path) => {
  router.push(path)
}
const onLogout = () => {
  ElMessageBox.confirm('确认退出登录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      event.emit(LOGOUT)
      // userStore.logout()
      // router.go(0)
    })
    .catch(() => {
      console.log('cancel')
    })
}
</script>
